import React from 'react';
import ResetPassword from './ResetPassword';
import VerifyEmail from './VerifyEmail';
import * as utils from '../util';

const UserAction = (props) => {

  //const query = new URLSearchParams(props.location.search);

  const mode = utils.URLParametersExtractor(props.location.search, 'mode');

  const actionCode = utils.URLParametersExtractor(props.location.search, 'oobCode');

  const continueUrl = utils.URLParametersExtractor(props.location.search, 'continueUrl');

  switch (mode) {
    case 'resetPassword':
      return <ResetPassword actionCode={actionCode} continueUrl={continueUrl} {...props}/>;
    case 'verifyEmail':
      return <VerifyEmail actionCode={actionCode} continueUrl={continueUrl} {...props}/>;
    default:
      return (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6  col-xs-8 form-center form-box" >
              <h6 className="text-center">Invalid Email Verification link</h6>
              <p className="error">Please click the valid link sent to your registered email-id.</p>
              <button className="btn btn-primary btn-block" onClick={()=> {props.history.push("/")}}>Continue Exploring SONIA Realised Rates</button>
            </div>
          </div>
        </div>
      );
  }
}

export default UserAction;



// WEBPACK FOOTER //
// ./src/components/UserAction.js